<script lang="ts">
    import TassV2Integration from '$lib/components/drawers/client/integrations/tass-v2/Integration.svelte';
    import XeroV3Integration from '$lib/components/drawers/client/integrations/xero-v3/Integration.svelte';
    import MyobAccountRightIntegration
        from '$lib/components/drawers/client/integrations/myob-account-right/Integration.svelte';
    import BusinessCentralIntegration
        from '$lib/components/drawers/client/integrations/business-central/Integration.svelte';
    import PlaceholderConfig from '$lib/components/drawers/client/integrations/PlaceholderConfig.svelte';
    import AccountsIQIntegration from '$lib/components/drawers/client/integrations/accountsiq/Integration.svelte';
    import BlackbaudIntegration from '$lib/components/drawers/client/integrations/blackbaud/Integration.svelte';
    import WCBSIntegration from '$lib/components/drawers/client/integrations/wcbs/Integration.svelte';
    import TechOneIntegration from '$lib/components/drawers/client/integrations/techone/Integration.svelte';
    import CompassIntegration from '$lib/components/drawers/client/integrations/compass/Integration.svelte';
    import SynergeticsIntegration from '$lib/components/drawers/client/integrations/synergetics/Integration.svelte';
    import MyobAcumaticaIntegration from '$lib/components/drawers/client/integrations/myobacumatica/Integration.svelte';
    import {isIntegration} from '$lib/components/drawers/client/integrations/isIntegration';

    export let clientId: number;
  export let clientName: string | undefined;
  export let clientKey: string | undefined;
  export let organisationId: string | undefined;
  export let connectionType: string;

  $: clientIdStr = clientId.toString();
</script>

<div class="space-y-4">
  {#if !connectionType}
    <div class="rounded-lg bg-gray-100 p-6 text-gray-600">This client has no integration configured. Set a Connect Type on the Client Details tab to unlock the config UI.</div>
  {:else if isIntegration(connectionType, 'TassV2')}
    <TassV2Integration {clientId} {clientKey} {organisationId} />
  {:else if isIntegration(connectionType, 'XeroV3')}
    <XeroV3Integration {clientId} {clientKey} {organisationId} />
  {:else if isIntegration(connectionType, 'MYOBAccountRightV2')}
    <MyobAccountRightIntegration {clientId} {clientKey} {organisationId} />
  {:else if isIntegration(connectionType, 'MSBusinessCentral')}
    <BusinessCentralIntegration {clientId} {clientKey} {organisationId} />
  {:else if isIntegration(connectionType, 'AccountsIQ')}
    <AccountsIQIntegration clientId={clientIdStr} entityId="" clientName={clientName ?? ''} {organisationId} />
  {:else if isIntegration(connectionType, 'Blackbaud')}
    <BlackbaudIntegration clientId={clientIdStr} entityId="" clientName={clientName ?? ''} {organisationId} />
  {:else if isIntegration(connectionType, 'WCBS')}
    <WCBSIntegration clientId={clientIdStr} entityId="" clientName={clientName ?? ''} {organisationId} />
  {:else if isIntegration(connectionType, 'TechOne')}
    <TechOneIntegration clientId={clientIdStr} entityId="" clientName={clientName ?? ''} {organisationId} />
  {:else if isIntegration(connectionType, 'Compass')}
    <CompassIntegration clientId={clientIdStr} entityId="" clientName={clientName ?? ''} {organisationId} />
  {:else if isIntegration(connectionType, 'MYOBAcumatica')}
    <MyobAcumaticaIntegration clientId={clientIdStr} entityId="" clientName={clientName ?? ''} {organisationId} />
  {:else if isIntegration(connectionType, 'Synergetics')}
    <SynergeticsIntegration {clientId} {organisationId} />
  {:else}
    <PlaceholderConfig integrationName={connectionType} />
  {/if}
</div>
